<ntk-header />

<div class="ntk-content">
  <div class="ntk-content__overlay"></div>
  <div class="ntk-content__inner">
    <router-outlet></router-outlet>
  </div>
</div>
